
<p>
  <list-format-display v-if="displayComponents.href"
                       :is-list="displayAsList"
                       :list-value="displayComponents.value"
                       :value="displayComponents.displayValue"
                       tag="a"
                       v-bind="linkAttrs"
  />
  <list-format-display v-else
                       :is-list="displayAsList"
                       :list-value="displayComponents.value"
                       :value="displayComponents.displayValue"
                       tag="span"
  />

  <button
    v-if="propertyHasSecurityMaskToggle"
    @click="toggleSecurityMask"
    class="btn-icon"
    :class="securityMaskActive ? 'light-grey' : 'grey'"
  >
    <span class="sr-only">{{ securityMaskActive ? "Show" : "Hide" }} masked data</span>
    <icon :class="securityMaskActive ? 'hide' : 'show'"></icon>
  </button>
</p>
